import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconReport$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconReport extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ce358923b6ce6073b1ec089d08cab79c94b1ccd6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '197ccce9a03afebe7cd0205a9bad63ed265e5b33', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd92534c3b26a2efb9580efca74d4e291fc202174', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.35 9.75h2.15a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-2.36a3.82 3.82 0 0 0-2.39-2.46V3.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2a4 4 0 0 0-2.71 1.2L7.76 4.94a.5.5 0 0 0-.71 0l-.35.35a.5.5 0 0 0 0 .71l1.77 1.77L6.28 10 4.52 8.18a.51.51 0 0 0-.71 0l-.35.35a.5.5 0 0 0 0 .71L5.24 11a4 4 0 0 0 5.64 5.64l1.77 1.77a.5.5 0 0 0 .71 0l.35-.35a.51.51 0 0 0 0-.71l-1.77-1.76 2.18-2.19 1.77 1.77a.5.5 0 0 0 .71 0l.35-.35a.5.5 0 0 0 0-.71l-1.76-1.76a4 4 0 0 0 1.16-2.6m-7.26 5.12L7 12.8a.5.5 0 0 1 0-.71l.35-.35a.51.51 0 0 1 .71 0l2.07 2.07a.5.5 0 0 1 0 .71l-.35.35a.5.5 0 0 1-.69 0m3.24-3.24-2.07-2.07a.5.5 0 0 1 0-.71l.35-.35a.5.5 0 0 1 .71 0l2.07 2.07a.5.5 0 0 1 0 .71l-.35.35a.5.5 0 0 1-.71 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-report", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-report"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-report":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconReport$1);
            }
            break;
    } });
}

const CosmosIconReport = CosmosIconReport$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconReport, defineCustomElement };
